module.exports = __webpack_public_path__ + "static/img/err.7cdacba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/err.png
// module id = qIkD
// module chunks = 1